// src/pages/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Phone, ArrowLeft } from 'lucide-react';
import Button from '../components/ui/Button';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 py-16">
      <div className="max-w-xl w-full bg-white shadow-lg rounded-lg p-8 text-center">
        <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
        <div className="w-16 h-1 bg-secondary mx-auto mb-6"></div>
        
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Page Not Found</h2>
        <p className="text-gray-600 mb-8">
          The page you are looking for might have been removed, had its name changed, 
          or is temporarily unavailable.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            href="/"
            variant="primary"
            size="lg"
            className="inline-flex items-center justify-center"
          >
            <Home className="mr-2 h-5 w-5" />
            Go Back Home
          </Button>
          
          <Button
            href="/services" 
            variant="outline"
            size="lg"
            className="inline-flex items-center justify-center"
          >
            <ArrowLeft className="mr-2 h-5 w-5" />
            View All Services
          </Button>
        </div>
      </div>
      
      <div className="mt-8 text-center">
        <p className="text-gray-600 mb-2">Need immediate assistance?</p>
        <Link to="/contact" className="text-primary hover:text-primary-dark inline-flex items-center">
          <Phone className="h-4 w-4 mr-2" />
          Contact our team
        </Link>
      </div>
    </div>
  );
};

export default NotFound;